var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 113,
    viewBox: "0 0 146 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9838 21.9878H18.9795C15.6658 21.9878 12.9795 24.6741 12.9795 27.9878V100.431",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0166 22.582H127.021C130.335 22.582 133.021 25.2683 133.021 28.582V100.431",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 104.648C1.5 101.887 3.73858 99.6479 6.5 99.6479H139.501C142.262 99.6479 144.501 101.887 144.501 104.648V106.91C144.501 109.672 142.262 111.91 139.501 111.91H6.49999C3.73857 111.91 1.5 109.672 1.5 106.91V104.648Z",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9839 30.3076H25.8936C23.6844 30.3076 21.8936 32.0985 21.8936 34.3076V88.1112C21.8936 90.3204 23.6844 92.1112 25.8936 92.1112H120.701C122.911 92.1112 124.701 90.3204 124.701 88.1112V34.3076C124.701 32.0985 122.911 30.3076 120.701 30.3076H92.6111",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.7959,
    y: 1,
    width: 38.41,
    height: 45.5412,
    rx: 5,
    fill: "#F2F3F4",
    stroke: "#194590",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5205 12.4795H78.3485",
    stroke: "#194590",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1152 28.5249H85.4801",
    stroke: "#194590",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1152 35.6558H85.4801",
    stroke: "#194590",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0042 57.1206V77.5206M61.7305 66.7838L73.0042 78.0574L84.2778 66.7838",
    stroke: "#194590",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCsv);
export default __webpack_public_path__ + "static/media/import_csv.dea9b8ecdf3faaab1dfa28bac11ba34a.svg";
export { ForwardRef as ReactComponent };